import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('../views/Join.vue')
  },
  {
    path: '/partner',
    name: 'partner',
    component: () => import('../views/Partner.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/DaiMin',
    name: 'DaiMin',
    component: () => import('../views/DaiMinHome.vue')
  },
  {
    path: '/Zfz',
    name: 'Zfz',
    component: () => import('../views/ZfzHome.vue')
  },
  {
    path: '/vitality',
    name: 'vitality',
    component: () => import('../views/Vitality.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/News.vue'),
  },
  {
    path: '/newsDetail/:id',
    name: 'newsDetail',
    component: () => import('../views/NewsDetail.vue'),
  },
  {
    path: '/TY',
    name: 'TY',
    component: () => import('../views/TY.vue')
  },
  // {
  //   path: '/ProductPage=:productId',
  //   name: 'ProductPage',
  //   component: () => import('../components/ProductPage.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router

